import React, { useRef, useEffect, useState, useCallback } from "react"
import { Container, Graphics, useTick } from "@inlet/react-pixi"
import Runner from "components/line-runner"
import { lerp, clamp } from "utils/math"
import { DropShadowFilter } from "@pixi/filter-drop-shadow"

const Line = ({ data, active }) => {
  const [time, setTime] = useState(0)
  //useEffect(() => setTime(0), [active])
  const ref = useRef()
  useTick((delta, x) => {
    setTime(prev => prev + x.elapsedMS)
    if (ref.current && !ref.current.filters) {
      ref.current.filters = [
        new DropShadowFilter({ distance: 0, blur: 2, alpha: 0.8 }),
      ]
    }
  })
  const draw = useCallback(
    g => {
      g.clear()
      g.lineStyle(2, /*0xffd720*/ 0xe295cd, 1)
      g.moveTo(30, data[0] * 60 + 30 + 60)
      for (let i = 1; i < 5; i++) {
        g.lineTo(30 + 60 * i, 60 * data[i] + 30 + 60)
      }
    },
    [data]
  )
  return (
    <Container>
      <Container
        alpha={
          time < 125
            ? time / 125
            : time < 375
            ? 1
            : 1 - lerp(0, 0.8, clamp((time - 375) / 125))
        }
      >
        <Graphics ref={ref} draw={draw} />
        {time < 750 && <Runner data={data} time={clamp(time / 500)} />}
      </Container>
    </Container>
  )
}

export default Line
